"use client";
import { cn, Modal, ModalContent } from "@heroui/react";
import _ from "lodash";
import React, { ReactNode } from "react";
import { IoIosClose } from "react-icons/io";
type MobileMenuProps = {
  isOpen: boolean;
  menuContent: ReactNode;
  onOpenChange: (value: boolean) => void;
};
export default function MobileMenu({ onOpenChange, isOpen, menuContent }: MobileMenuProps) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      motionProps={{
        variants: {
          enter: {
            x: 0,
            transition: {
              duration: 0.3,
              ease: "easeOut",
            },
          },
          exit: {
            x: "100%",
            transition: {
              duration: 0.2,
              ease: "easeIn",
            },
          },
        },
      }}
      closeButton={<IoIosClose size={24} />}
      classNames={{
        // base: cn("sm:hidden"),
        closeButton: cn("fixed top-0 left-0 size-12 text-white"),
        wrapper: cn("ml-auto mr-0 w-[320px] h-svh"),
      }}
    >
      <ModalContent className="h-svh rounded-none px-0 !m-0">{menuContent}</ModalContent>
    </Modal>
  );
}
